'use client';

import React from 'react';

interface BrandMarkProps {
  compact?: boolean;
  className?: string;
  textClassName?: string;
  taglineClassName?: string;
}

const BrandMark = ({
  compact = false,
  className = '',
  textClassName = 'text-foreground',
  taglineClassName = 'text-muted-foreground',
}: BrandMarkProps) => {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/advika-mark.png"
        alt="Advika"
        className="h-10 w-10 shrink-0 rounded-xl shadow-[0_12px_28px_rgba(109,94,244,0.24)]"
      />
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className={`font-heading text-xl font-bold ${textClassName}`}>Advika</span>
          <span className={`mt-1 text-[11px] font-semibold uppercase ${taglineClassName}`}>
            Intelligent OS
          </span>
        </span>
      )}
    </span>
  );
};

export default BrandMark;
